module.exports = __webpack_public_path__ + "static/media/mosk_medium_500-webfont.16c9f738.woff2";